import React, { useState, useRef } from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip } from '@mui/material';
import { PrintOutlined, InfoOutlined, Close } from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';
import Loading from 'components/Loading';
import AppDataTableComponent from './AppDataTableComponent';
import OverAllGraph from 'components/PlacementExam/OverAllGraph';
import SpinLoader from 'components/Loader/SpinLoader';
import './AppDataTable.css';
import SentryWrap from 'components/Sentry';

const skillAreaLegend = [
  { display: 'Speaking', description: 'Speaking' },
  { display: 'Listening', description: 'Listening' },
  { display: 'Reading', description: 'Reading' },
  { display: 'Writing', description: 'Writing' },
  { display: 'Comprehension', description: 'Comprehension (Listening + Reading)' },
  { display: 'Literacy', description: 'Literacy (Reading + Writing)' },
  { display: 'Vocal', description: 'Vocal (Listening + Speaking)' },
  { display: 'Active', description: 'Active (Speaking + Writing)' },
];

export default function AppDataTable({ overAllData, loader, overallReport }) {
  const printRef = useRef(null);
  const [printLoader, setPrintLoader] = useState(false);
  const [legendOpen, setLegendOpen] = useState(false);

  const printCall = useReactToPrint({
    contentRef: printRef,
    onBeforeGetContent: async () => {
      setPrintLoader(true);
      if (printRef.current) {
        printRef.current.style.height = 'auto';
        printRef.current.style.overflow = 'visible';
      }
    },
    onBeforePrint: async () => {
      setPrintLoader(false);
      if (printRef.current) {
        printRef.current.style.height = '';
        printRef.current.style.overflow = '';
      }
    },
  });

  return (
    <SentryWrap>
      <div style={{ position: 'relative' }}>
        <div className="skill-report-table-print-button-container">
          <Tooltip title="Skill area legend">
            <IconButton
              onClick={() => setLegendOpen(true)}
              className="skill-report-table-print-button mr-10px"
              aria-label="legend"
            >
              <InfoOutlined />
            </IconButton>
          </Tooltip>
          <IconButton
            onClick={() => printCall()}
            className="skill-report-table-print-button"
            aria-label="print"
          >
            {printLoader ? <Loading size={20} /> : <PrintOutlined />}
          </IconButton>
        </div>
        <div className="printable" ref={printRef}>
          <AppDataTableComponent overallReport={overallReport} />
        </div>
      </div>

      <Dialog open={legendOpen} onClose={() => setLegendOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Skill Area Legend
          <IconButton onClick={() => setLegendOpen(false)} aria-label="close" size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {skillAreaLegend.map((item) => (
              <li key={item.display} style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                <strong>{item.display}</strong>
                {item.display !== item.description && (
                  <span style={{ marginLeft: 8 }}>{item.description.replace(item.display, '').trim()}</span>
                )}
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>

      <div className="width-100 mt-10px">
        <SpinLoader dataloader={loader} />
        {overAllData && Object.keys(overAllData).length > 0 && (
          <OverAllGraph overAllData={overAllData} />
        )}
      </div>
    </SentryWrap>
  );
}
